import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Interaccion/List',
  documento: 'crm',
  filas: ['143'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/InteraccionController.cs',
} satisfies RutaProd;
